import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  forwardRef,
} from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'toggler',
  templateUrl: './toggler.component.html',
  styleUrls: ['./toggler.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TogglerComponent),
      multi: true,
    },
  ],
})
export class TogglerComponent extends ControlValueAccessorDirective {
  @Input() attrName!: string;
  @Input() title: string = '';
  @Input() public readonly: boolean = false;
  @Input() public control!: FormControl;

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  public get Invalid(): boolean {
    return this.control?.invalid ?? false;
  }

  public get ShowError(): boolean {
    if (!this.control) return false;
    this.cdr.markForCheck(); // Trigger change detection
    const { dirty, touched } = this.control;
    return this.Invalid ? dirty || touched : false;
  }
}
